import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material';
import {
  label as formControlLabelLabel,
  labelPlacementStart as formControlLabelPlacementStart,
  root as formControlLabelRoot,
  small as formControlLabelSmall,
} from 'ui/FormControlLabel/formControlLabelCssDefs';
import React from 'react';

export type FormControlLabelProps = Omit<MuiFormControlLabelProps, 'labelPlacement'> & {
  /**
   * The position of the label text. Default is end.
   */
  labelPlacement?: 'start' | 'end';
  /**
   * Size of the control.
   */
  size?: 'small' | 'medium';
};

/**
 * Label component for Radio and Checkbox elements
 * First line of label text is vertically centered relative to the control height.
 * If the text wraps the control will stay centered with the first line.
 *
 * Custom label components will need to implement their own margin/padding
 *
 * Related Components: ui/Checkbox, ui/Radio, ui/FormCheckbox
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const FormControlLabel = React.forwardRef<HTMLLabelElement, FormControlLabelProps>(
  ({ className, control, size = 'medium', labelPlacement = 'end', ...rest }, ref) => {
    return (
      <MuiFormControlLabel
        css={[
          formControlLabelRoot,
          formControlLabelLabel,
          size === 'small' && formControlLabelSmall,
          labelPlacement === 'start' && formControlLabelPlacementStart,
        ]}
        className={className}
        control={React.cloneElement(control, { size })}
        labelPlacement={labelPlacement}
        ref={ref}
        {...rest}
      />
    );
  }
);

export default FormControlLabel;
